<div class="overlay-spinner">
    <div class="loading-dialog" role="status">
        <div class="loading-logo-wrapper">
            <img src="assets/images/svg/loading-logo.svg" alt="" class="loading-logo" />
        </div>
        <span class="loading-text">{{ message }}</span>
    </div>
</div>